import { h } from 'preact';
import styled, { css } from 'styled-components';
import { useEffect, useState } from 'preact/hooks'

import getStyle from '../utils/getStyle';

const HeaderMenu = ({config}) => {
    const [childMenuActive,setChildMenuActive] = useState(false);    
    const [activeChildMenu, setActiveChildMenu] = useState(0);
    const [fadeIn,setFadeIn] = useState(false);

    useEffect(() => {
        setFadeIn(true);
    }, [])

    return (
        <_HeaderMenu onMouseLeave={() => {
            setChildMenuActive(false);
        }}>
            <HeaderMenu__Parents fadeIn={fadeIn}>
                {
                    config?.menu.map(({title,url,active}, i) => (
                        <HeaderMenu__Parent>
                            <HeaderMenu__Parent__Toggle 
                                active={active}
                                href={url}                                
                                onMouseEnter={() => {
                                    const hasChildren = Boolean( config.menu[i].children.length);
                                    if(childMenuActive && i === activeChildMenu) {
                                        setChildMenuActive(false);
                                    } else if(!childMenuActive && hasChildren) {
                                        setActiveChildMenu(i); 
                                        setChildMenuActive(true);                       
                                    } else if(hasChildren) {
                                        setActiveChildMenu(i);
                                    } else if(!hasChildren) {
                                        setChildMenuActive(false);
                                    }
                                }}
                                dangerouslySetInnerHTML={{__html:title}}
                            />
                        </HeaderMenu__Parent>
                    ))
                }
            </HeaderMenu__Parents>
            <HeaderMenu__Children active={childMenuActive}>
                {
                    config?.menu.map(({children}, i) => (
                        <HeaderMenu__ChildContainer>
                             <HeaderMenu__ChildMenu
                                active={activeChildMenu === i}
                                menuActive={childMenuActive}>
                                {
                                    children.map(({title,url,active}) => (
                                        <HeaderMenu__Child>
                                            <HeaderMenu__Child__Link href={url} active={active}>
                                                {title}
                                            </HeaderMenu__Child__Link>
                                        </HeaderMenu__Child>
                                    ))
                                }
                            </HeaderMenu__ChildMenu>                      
                        </HeaderMenu__ChildContainer>
                    ))
                }
            </HeaderMenu__Children>
        </_HeaderMenu>
    );
};

const _HeaderMenu = styled.div`
    height: 100%;    
`;

const HeaderMenu__Parents = styled.ul`
    height: 100%;
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    transition: opacity 200ms ease;
    opacity: ${({fadeIn}) => fadeIn ? 1 : 0};
`;

const HeaderMenu__Parent = styled.li``;

const HeaderMenu__Parent__Toggle = styled.a`
    appearance: none;
    padding: 16px;
    border: none;
    background: transparent;
    font-size: ${getStyle('font-sizes.large')};
    text-transform: uppercase;
    font-weight: bold;
    cursor: pointer;
    transition: color 200ms ease;
    color: color(text);
    text-decoration: none;
    color: ${getStyle('colors.primary--black')};
    font-weight: 800;

    &:hover {
        color: ${getStyle('colors.primary--normal')};
    }

    @media (min-width: ${getStyle('breakpoints.xlg')}) {
        font-size: ${getStyle('font-sizes.heading4')};
    }

    ${({active}) => active ? css`
        color: ${getStyle('colors.primary--normal')};
    ` :''}
`;

const HeaderMenu__Children = styled.div`
    height: 0;
    min-height: ${({active}) => active ? '50px' : 0};
    margin: 0;
    overflow: hidden;
    position: absolute;   
    width: 100vw;
    background-color: ${getStyle('colors.surfaces--grey')};
    transition: min-height 200ms ease;
    z-index: 1;
    top: 105px;
    left: 0;

    @media (min-width: ${getStyle('breakpoints.lg')}) {
        top: 80px;
    }
`;

const HeaderMenu__ChildContainer = styled.div``;

const HeaderMenu__ChildMenu = styled.ul`
    margin: 0 auto;
    list-style: none;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    transition: ${({active}) => active ? 'opacity 200ms ease' : 'none'};
    opacity: ${({active}) => active ? 1 : 0};
    pointer-events: ${({active}) => active ? 'auto' : 'none'};
`;

const HeaderMenu__Child = styled.li``;

const HeaderMenu__Child__Link = styled.a`
    padding: 17px 16px;
    line-height: 1;
    color: ${getStyle('colors.text')};
    text-decoration: none;
    letter-spacing: 0.34px;
    font-size: ${getStyle('font-sizes.body')};
    display: block;
    white-space: nowrap;
    transition: color 200ms ease;
    color: ${getStyle('colors.primary--black')};
    font-weight: 900;
    text-transform: uppercase;

    &:hover {
        color: ${getStyle('colors.primary--normal')};
    }

    ${({active}) => active ? css`
        color: ${getStyle('colors.primary--normal')};
    ` :''}
`;

export default HeaderMenu;